@if(campanha && perfilParticipante) {
  <div class="container home-screen">
    <div>
      @if(!isStatusConcluido){
      <span class="status-chip" [ngClass]="{
      'status-amarelo': perfilParticipante.status === EnumStatus.Pendente || perfilParticipante.status === EnumStatus.Cancelado || perfilParticipante.status === EnumStatus.Iniciado,
      }">
        Pendente
      </span>
      }
      <h1 class="page-title">Perfil de investidor</h1>
      <p class="page-description">
        {{ campanha.descricao }}
      </p>
  
      <div class="summary-section">
        <div class="summary-cards">
          <app-summary-card 
          label="Perfil atual:"
          [value]="perfilParticipante.perfilAtual">
          </app-summary-card>

          <app-summary-card 
          label="Data limite para atualização:"
          [value]="campanha.dtaFim | date:'dd/MM/yyyy'">
          </app-summary-card>

          <app-summary-card 
          label="Tempo estimado para finalizar:"
          [value]="'5 minutos'">
          </app-summary-card>
        </div>
      </div>
    </div>
  
    <div class="instruction position-relative">
      <div>
        <h2 class="title-instruction">Como funciona?</h2>
        @if(campanha.instrucao){
          <p class="description-instruction">
            {{ campanha.instrucao }}
          </p>
        }
      </div>
  
      <div class="how-it-works-steps">
        <!-- Item 1 (fixo) -->
        <div class="step-item">
          <span class="step-number">1</span>
          <div class="step-content">
            <h3 class="step-title">Preencha o questionário</h3>
            <p class="step-description">Responda às perguntas para identificarmos o perfil de investimento mais adequado para você.</p>
          </div>
        </div>

        <!-- Item 2 (dinâmico — perfis vindos do endpoint) -->
        <div class="step-item">
          <span class="step-number">2</span>
          <div class="step-content">
            <h3 class="step-title">Selecione o perfil de investidor</h3>
            <p class="step-description">Com base nas suas respostas, escolha o perfil que melhor representa seus objetivos e sua tolerância a riscos.</p>
            <div class="step-profiles">
              @for (perfil of perfisInvestidor; track perfil.idPerfilInvestimento) {
                <p class="step-profile">
                  <strong>{{ perfil.nomePerfilInvestimento }}:</strong> {{ perfil.descricaoPerfilInvestimento }}
                </p>
              }
            </div>
          </div>
        </div>

        <!-- Item 3 (fixo) -->
        <div class="step-item">
          <span class="step-number">3</span>
          <div class="step-content">
            <h3 class="step-title">Assine o termo</h3>
            <p class="step-description">Leia atentamente as informações e confirme seu aceite para prosseguir com a sua solicitação.</p>
          </div>
        </div>

        <!-- Item 4 (fixo) -->
        <div class="step-item">
          <span class="step-number">4</span>
          <div class="step-content">
            <h3 class="step-title">Pronto!</h3>
            <p class="step-description">Seu processo foi concluído com sucesso. Clique em Iniciar para continuar.</p>
          </div>
        </div>
      </div>

      <div class="button-content">
        <button class="btn btn-outline-primary">Voltar</button>
        <button class="btn btn-primary" type="button" (click)="goToQuestionnaire()">
          Iniciar
        <img src="assets/images/icons/fi_arrow-right.svg" alt="arrow-right"/>
      </button>
      </div>
    </div>
  </div>
}